export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_vi.073f6383d6d10694.json"